<div class="ac-pagination flexRowParent">

    <div *ngIf="_pageSizeOptions" class="ac-pagination-item flexItem">
        <div>Item per page:</div>
        <ac-input-container class="ac-pagination-select" [upperPadding]="false">
            <ac-single-select bindLabel="value"
                              [items]="_pageSizeOptions"
                              [acModel]="_pageSize"
                              (acModelChange)="onPageSizeChange($event)">
            </ac-single-select>
        </ac-input-container>
    </div>

    <div [hidden]="!showItemDisplay" class="ac-pagination-item ac-pagination-items-display flexItem">
        <ng-template *ngTemplateOutlet="itemsDisplayTemplate || defaultItemsDisplayTemplate[itemsDisplayType];
                     context: _totalElements | acFunc : getItemRangeContext : _pageIndex : _pageSize"
        ></ng-template>

        <ng-template let-totalElements let-pageIndex="pageIndex" let-pageSize="pageSize" #itemsRange>
            {{totalElements | acFunc : getFromPageElements : pageIndex : pageSize}}
            -
            {{totalElements | acFunc : getToPageElements : pageIndex : pageSize}} of {{_totalElements}}
        </ng-template>

        <ng-template let-totalElements #itemsCount>Displaying {{totalElements}} items</ng-template>
    </div>

    <div *ngIf="pageSelector" class="ac-pagination-item ac-pagination-page-select flexItem">

        <ac-button *ngIf="showFirst" class="clear first_page ac-pagination-button"
                   (click)="onPageIndexChange(1)" [ngDisabled]="isFirstPage">
            <ac-svg name="first_page" [fillColor]="isFirstPage | acFunc : getButtonStateColor"></ac-svg>
        </ac-button>

        <ac-button class="clear previous ac-pagination-button" (click)="onPageIndexChange(_pageIndex - 1)"
                   [ngDisabled]="isFirstPage">
            <ac-svg name="previous" [fillColor]="isFirstPage | acFunc : getButtonStateColor"></ac-svg>
        </ac-button>

        <ac-input-container class="ac-pagination-select" [upperPadding]="false">
            <ac-single-select *ngIf="pagePicker; else pageIndexTemplate" selectId="pagination"
                              [selectFirstAfterSort]="false"
                              [acModel]="_totalElements ? _pageIndex : 1"
                              [items]="_totalElements | acFunc : getPages : _pageSize : pageValuesMap"
                              [itemTemplate]="pageSelectTemplate"
                              [labelTemplate]="pageSelectTemplate"
                              (acModelChange)="onPageIndexChange($event)">
            </ac-single-select>
        </ac-input-container>

        <ng-template #pageIndexTemplate>
            <span class="ac-pagination-page-index">{{_pageIndex}}</span>
        </ng-template>

        <ac-button class="clear next ac-pagination-button" (click)="onPageIndexChange(_pageIndex + 1)"
                   [ngDisabled]="isLastPage">
            <ac-svg name="previous" [fillColor]="isLastPage | acFunc : getButtonStateColor" [mirrorHor]="true"></ac-svg>
        </ac-button>

        <ac-button *ngIf="showLast" class="clear last_page ac-pagination-button"
                   (click)="onPageIndexChange(getTotalPages(_totalElements, _pageSize))"
                   [ngDisabled]="isLastPage">
            <ac-svg name="first_page" [fillColor]="isLastPage | acFunc : getButtonStateColor"
                    [mirrorHor]="true"></ac-svg>
        </ac-button>
    </div>
</div>
